<template>
    <zj-layout-container class="zj-address-book-manage">
      <zj-layout-header>
        <div class="listtitle">应急通讯录</div>
        <el-form class="zj-search-form" ref="form" :model="form">
          <el-form-item label="人员姓名" prop="name">
            <el-input v-model="name"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="bgcolor" style="height:100%;padding:1rem 1rem;">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
            :key="item.name"
            v-for="(item) in options"
            :label="item.value"
            :name="item.code"
          >
          <Addrescueteamlist
              :ref="item.code"
              :belongDeptType="item.code"
            />
            </el-tab-pane>
          </el-tabs>
        </div>
      </zj-layout-main>
      <zj-layout-footer></zj-layout-footer>
    </zj-layout-container>
</template>

<script>
import ZJApp from '../../../../../app';
import Addrescueteamlist from "./Addrescueteamlist";
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";

export default {
  name: "ZJAddressbookManage",
  controller: "EmergencyResource",
  action: "AddressbookManage",
  components: {
    Addrescueteamlist
  },
  data() {
    return {
      //默认第一个选项卡
      activeName: "",
      name: null,
      options:[]
    };
  },
  created() {
    this.loading = true;
    this.loadingText = '加载中...';
    return utils.waitAll([
      getDictionary('organization_type'),
    ])
    .then(r => {
      let d;

      d = r[0];
      this.options = d.data.records;
      this.activeName=this.options[0].code;
      
      this.loading = false;

      return r;
    })
    .catch(e => {
      console.error(e);
      this.loading = false;
    });
  },
  mounted(){
  },
  methods: {
    searchfun() {
      let param = {
        name: this.name,
        belongDeptType: this.activeName,
        size: 2000,
        current: 1,
      };
      var actobj = this.$refs[this.activeName][0];
      actobj.searchinfo(param);
    },
    onSearch() {
      this.searchfun();
    },
    handleClick() {
      this.searchfun();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.searchfun();
    },
    clearsearch() {
      this.name = null;
    }
  }
};
</script>

<style>
/* tab 顶部样式 */
.zj-address-book-manage .el-tabs {
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}
.zj-address-book-manage .el-tabs__header {
  flex: 0 0 auto;
}
.zj-address-book-manage .el-tabs__content {
  flex: 1 1 auto;
}
.zj-address-book-manage .el-tab-pane {
  height: 100%;
  overflow: hidden;
}
.zj-address-book-manage .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
.zj-address-book-manage .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 2rem;
}

.zj-address-book-manage .el-tabs--top .el-tabs__item {
  color: #acb8c7;
  font-size: 1.6rem;
}

.zj-address-book-manage .el-tabs--top .el-tabs__item.is-active {
  color: #ffffff;
  font-size: 1.6rem;
}

.zj-address-book-manage .el-tabs--top .el-tabs__item:hover {
  color: #ffffff;
  font-size: 1.6rem;
  cursor: pointer;
}

.zj-address-book-manage .el-tabs--top .el-tabs__nav {
  padding-bottom: 1rem;
}

.zj-address-book-manage .el-tabs--top .el-tabs__nav-next,
.zj-address-book-manage .el-tabs__nav-prev {
  font-size: 1.6rem;
  color: #2ac1ff;
}

.zj-address-book-manage .el-tabs--top .el-tabs__nav-wrap::after {
  background-color: transparent;
}

.zj-address-book-manage .el-tabs--top .el-tabs__active-bar {
  bottom: 1.2rem;
  height: 2px;
  background-color: #409eff;
  border-radius: 2px;
  box-shadow: 0px 0.5rem 0.5rem rgba(64, 158, 255, 0.7);
}

.zj-address-book-manage .group-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;
}
.zj-address-book-manage .el-tab-pane .labelgroup {
  color: #acb8c7;
  font-size: 1.6rem;
  padding: 0rem 0rem 1rem 0.3rem ;
}
.zj-address-book-manage .divider-bar {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.zj-address-book-manage .group-bar {
  flex: 1 1 auto;
  overflow: hidden;
  position: relative;
}
.zj-address-book-manage .group-bar .el-table {
  position:absolute;
}
</style>